import apiClient from "./apiClient";
const resource = "/backups";

export default {
  async getBackups() {
    return apiClient.get(`${resource}`);
  },
  async createBackup() {
    return apiClient.post(`${resource}`);
  },
  async downloadBackup(filename) {
    return apiClient.get(`${resource}/${filename}/download`, { responseType: 'blob' });
  },
  async deleteBackup(filename) {
    return apiClient.delete(`${resource}/${filename}`);
  },
};
